
import dayjs from 'dayjs'
import { toggleClassName } from '~/utils'

export default {
    name: 'DailySchedule',

    components: {},

    props: {
        scheduleItems: Array,
        title: String,
        itemId: String,
    },

    data() {
        return {
            now: dayjs(),
            firstContentMarked: false,
            searchWord: '',
        }
    },

    watch: {
        itemId() {
            const selector = document.getElementById(this.itemId)

            selector.classList.add('on')
        },
    },

    methods: {
        onClickRow(target) {
            // console.log('onClickRow target', target)

            toggleClassName(target, 'on')
        },

        onClickSearch() {
            // this.searchWord
            console.log('onClickSearch this.searchWord', this.searchWord)
        },

        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=960px,height=1000,scrollbars=1,resizable=yes'
            )
        },

        onClickTheme(themeCode) {
            // window.open(`/Theme/ThemeDB/ThemeAllAllowed/${themeCode}`, '', '_blank')
            window.open(`https://new.infostock.co.kr/Theme/ThemeDB/ThemeAllAllowed/${themeCode}`, '', '_blank')
            // this.$router.push(`/Theme/ThemeDB/ThemeAllAllowed/${themeCode}`)
        },
    },
}
